import { useTranslation } from 'react-i18next'
import { TableCell, TableRow, Typography, Box, IconButton } from '@mui/material'
import { Visibility } from '@mui/icons-material'

import { PlayerTransactionTableItem } from '../../hooks'

type Props = {
  row: PlayerTransactionTableItem
  onViewDetails: (row: PlayerTransactionTableItem) => void
}

export const TransactionsTableStandardRow = ({ row, onViewDetails }: Props) => {
  const { t } = useTranslation()

  return (
    <TableRow hover>
      <TableCell>{row.transactionDate || '-'}</TableCell>
      <TableCell>
        {row.externalTransactionId ? row.externalTransactionId : '-'}
      </TableCell>
      <TableCell>
        {row.transactionType
          ? t(`transaction.transactionTypeOptions.${row.transactionType}`)
          : '-'}
      </TableCell>
      <TableCell>
        {t(`transaction.transactionStatusOptions.${row.transactionStatus}`)}
      </TableCell>
      <TableCell>
        {row.walletType ? t(`transaction.walletType.${row.walletType}`) : '-'}
      </TableCell>
      <TableCell>{row.provider ? row.provider : '-'}</TableCell>
      <TableCell>
        <Box display="flex" flexDirection="column" lineHeight={1.2}>
          <Typography variant="body2" fontWeight={500}>
            {row.group ? row.group : '-'}
          </Typography>

          {row.subGroup && (
            <Typography variant="caption" color="text.secondary">
              {row.subGroup}
            </Typography>
          )}
        </Box>
      </TableCell>
      <TableCell>{row.amountText || row.amount}</TableCell>
      <TableCell>{row.balanceBeforeText || row.balanceBefore}</TableCell>
      <TableCell>{row.balanceAfterText || row.balanceAfter}</TableCell>
      <TableCell>
        <IconButton size="small" onClick={() => onViewDetails(row)}>
          <Visibility fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
